import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import PageTabs from '../../../components/PageTabs';
import { UserList, ArrowCounterClockwise } from '@phosphor-icons/react';

const ManagerCustomersTab = ({ children, darkMode }) => {
  const { slug } = useParams();
  const { user } = useAuth();
  const isServicesType = ['SERVICES', 'SALON'].includes(user?.businessType);

  const tabs = [
    { key: 'customers', label: 'Customers', icon: UserList, path: `/${slug}/manager/customers` },
    ...(!isServicesType ? [
      { key: 'returns', label: 'Returns', icon: ArrowCounterClockwise, path: `/${slug}/manager/customers/returns` },
    ] : []),
  ];

  return (
    <>
      <PageTabs tabs={tabs} darkMode={darkMode} />
      {children}
    </>
  );
};

export default ManagerCustomersTab;
